export default __webpack_public_path__ + "static/media/item-image.a22fe273.svg";